<ngx-sonner-toaster
    position="top-center"
    duration="4000"
    visibleToasts="4"
    [toastOptions]="{
        classes: {
            toast: 'qpx-toast',
            title: 'qpx-toast-title',
            description: 'qpx-toast-description',
            actionButton: 'qpx-toast-action-button',
            cancelButton: 'qpx-toast-cancel-button',
            closeButton: 'qpx-toast-close-button',
        },
    }"
>
    <qpx-hero-icon
        success-icon
        name="lucideCircleCheckBig"
        context="success"
        size="sm"
    />
    <qpx-hero-icon info-icon name="lucideInfo" context="info" />
    <qpx-hero-icon error-icon name="lucideCircleAlert" context="destructive" />
    <qpx-hero-icon warning-icon name="lucideTriangleAlert" context="caution" />
    <span loading-icon class="qpx-toast-loader">
        <qpx-loader
            context="secondary"
            tone="muted"
            containerClass=""
            [diameter]="20"
            ariaLabel="Loading"
        />
    </span>
</ngx-sonner-toaster>

<!-- Splash must immediately precede qpx-splashable for splash state styling. -->
<qpx-splash />
<router-outlet class="qpx-splashable" />
